import { Box, useMediaQuery, useTheme } from '@mui/material';

interface LogoProps {
    width?: number;
    height?: number;
    excludeThemeSwitching?: boolean;
}

const Logo: React.FC<LogoProps> = ({ width, height, excludeThemeSwitching = false }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    // Determine which logo to use based on theme mode
    const logoSrc = excludeThemeSwitching 
        ? "/logo-fox.png" 
        : theme.palette.mode === 'dark' 
            ? "/coinfox-logo.png"  // White/light text for dark mode
            : "/coinfox-logo-light.png"; // Black text for light mode
    
    // Use original sizing for Auth Layout, new sizing for theme-aware logos
    const foxSize = excludeThemeSwitching 
        ? (isMobile ? 32 : 40)
        : (isMobile ? 120 : 150); // Larger size for full logo with text
    
    const foxHeight = excludeThemeSwitching
        ? (isMobile ? 32 : 40)
        : (isMobile ? 36 : 45); // Maintain aspect ratio for full logo
    
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            px: excludeThemeSwitching ? (isMobile ? 0 : 2) : 0,
        }}>
            {/* Logo */}
            <Box 
                component="img"
                src={logoSrc}
                alt="CoinFox"
                sx={{
                    width: width || foxSize,
                    height: height || foxHeight,
                    objectFit: 'contain',
                }}
            />
        </Box>
    );
};

export default Logo;
